<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" :width="width" :height="height"><g stroke-linecap="round" stroke-linejoin="round" :stroke-width="strokewidth" :fill="_secondaryfill" :stroke="_secondaryfill"><polyline fill="none" points="2,13 24,3 46,13 "></polyline> <path fill="none" d="M20,40.672 c0-1.208-0.529-2.357-1.476-3.108C17.078,36.416,14.57,35,11,35s-6.078,1.416-7.524,2.564C2.529,38.315,2,39.464,2,40.672V43h18 V40.672z" :stroke="fill"></path> <path fill="none" d="M16,24c0,2.761-2.239,6-5,6 s-5-3.239-5-6s2.239-5,5-5S16,21.239,16,24z" :stroke="fill"></path> <path fill="none" d="M46,40.672 c0-1.208-0.529-2.357-1.476-3.108C43.078,36.416,40.57,35,37,35s-6.078,1.416-7.524,2.564C28.529,38.315,28,39.464,28,40.672V43h18 V40.672z" :stroke="fill"></path> <path fill="none" d="M42,24c0,2.761-2.239,6-5,6 s-5-3.239-5-6s2.239-5,5-5S42,21.239,42,24z" :stroke="fill"></path></g></svg></template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: "100%"
		},
		height: {
			type: [Number, String],
			default: "100%"
		},
		strokewidth: {
			type: [Number, String],
			default: 1
		},
		fill: {
			type: String,
			default: "currentColor"
		},
		secondaryfill: {
			type: String
		}
	},
	computed: {
		_secondaryfill: function () {
			return this.secondaryfill || this.fill
		}
	}
}
</script>